import React from 'react';
import { pipe, } from 'ramda';
import { connect, } from 'react-redux';
import { Redirect, } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

import WithPaper from 'common/hocs/WithPaper';
import SvgIcon from 'common/components/SvgIcon';
import { useWidth, } from 'common/hooks';
import { StoreBasicDataApiStructure,} from 'common/types';
import InfoIcon from 'assets/icons/icon_info.svg';
import { repositories,} from 'api';
import { ResponsivePropsSettingsType, } from './types';
import { pages } from 'styles';

const responsivePropsSettings: ResponsivePropsSettingsType = {
    xs: {
        typography: {
            paragraph: true,
            variant: 'body1',
        },

        icon: {
            height: 35,
        },
    },

    _default: {
        typography: {
            paragraph: false,
            variant: 'h6',
        },

        icon: {
            height: 40,
        },
    }
};

type Props = {
    isError: boolean,
};

const AccessInformation: React.FC<Props> = ({ isError, }) => {
    const currentScreenPosition = useWidth();
    const settings = responsivePropsSettings[currentScreenPosition] ?? responsivePropsSettings._default;
    const typographyClasses = pages.accessInformation.makeParagraphStyles();

    if (!isError) {
        return (
            <Redirect to="/" />
        );
    }

    return (
        <Grid container
              justify="center">
            <Grid item
                  xs={12}
                  md={11}>
                <Box display="flex"
                     my={{ xs: 2, sm: 10, }}>
                    <Box marginTop={1}
                         marginRight={{ xs: 2, sm: 4, }}>
                        <SvgIcon src={InfoIcon}
                                 height={settings.icon.height} />
                    </Box>
                    <div>
                        <Typography variant={settings.typography.variant}
                                    classes={typographyClasses}
                                    paragraph>
                            Zamówienia mogą składać nauczyciele, dyrektorzy lub osoby do tego upoważnione (pełnomocnicy), którym Gdańskie Wydawnictwo Oświatowe nadało uprawnienia do składania zamówień dotacyjnych.
                        </Typography>
                        <Typography variant={settings.typography.variant}
                                    classes={typographyClasses}
                                    paragraph>
                            Aby uzyskać uprawnienia, skontaktuj się z&nbsp;Biurem Obsługi Klienta telefonicznie (58) 340 63 53 lub e-mailowo <Link href="mailto:bok@gwo.pl">bok@gwo.pl</Link>.
                        </Typography>
                    </div>
                </Box>
            </Grid>
        </Grid>
    );
};

type MappingType = {
    me: StoreBasicDataApiStructure<repositories.MeType>,
};

const mapStateToProps = ({ me }: MappingType) => ({ isError: me.isError, });

export default pipe<any, any, any>(
    WithPaper(null),
    connect(mapStateToProps),
)(AccessInformation);
